module.exports = __webpack_public_path__ + "img/product-showcase-video-poster.7e70eb67.jpg";